// 里の店の看板娘のセリフ（AIではなく決まった言葉）。来たときは時間帯のあいさつ、操作や状態に応じて返す。同じ場面に何パターンかあり、続けて同じにならないように選ぶ。
// こまち（米問屋・たぬき娘）は気さくな「〜だよ」、あかね（万屋・狐娘）はしっかり者の「〜ですよ」
export type Daypart = 'morning' | 'day' | 'evening' | 'night';

/** 日本時間の時間帯（朝5〜10時・昼〜16時・夕方〜19時・夜） */
export function daypart(now = Date.now()): Daypart {
  const h = new Date(now + 9 * 3600_000).getUTCHours();
  return h >= 5 && h < 10 ? 'morning' : h < 16 && h >= 10 ? 'day' : h >= 16 && h < 19 ? 'evening' : 'night';
}

export const KOMACHI = {
  greet: {
    morning: ['おはよう！ 帳場、いま開けたとこだよ', '早いね。朝の米蔵は冷えてて気持ちいいんだ'],
    day: ['いらっしゃい！ 今日も米俵、山積みだよ', 'お昼は食べた？ 腹が減っては戦はできないよ'],
    evening: ['おつかれさま。今日の戦はどうだった？', '夕方はひと息つく頃だね。ゆっくりしてって'],
    night: ['こんな夜更けに？ 帳簿つけてたとこだから、いいよ', '夜は冷えるね。兵糧はちゃんと蓄えてる？'],
  },
  ready: ['余った兵糧、チケットにしとこうか？', '交換なら任せて。勘定は早いよ', '兵糧30で、掃討チケット10枚だよ'],
  short: ['兵糧、あと{n}だね', 'あと{n}あれば、1回替えられるよ'],
  full: ['チケット、もう持ちきれないみたい。先に使っておいで', 'チケットの束がいっぱいだよ。掃討で使ってからまた来てね'],
  locked: ['交換には、この通い帳が要るんだ', '通い帳があれば、兵糧をチケットに替えられるよ'],
  done: ['はい、チケット{n}枚。まいど！', '勘定ぴったり。また来てね', '確かに。チケット{n}枚、お渡しだよ'],
  poke: ['算盤の音、好きなんだよね', 'この尻尾？ …触っちゃだめだよ', '米は一粒でも大事にね', 'あかねの店、品揃えすごいよね', 'ぱちぱちっと。今日も帳尻ぴったり'],
};

export const AKANE = {
  greet: {
    morning: ['おはようございます。朝一番の品出し、済んでますよ', '早起きですね。棚、いま整えたところです'],
    day: ['いらっしゃいませ。品物、そろってますよ', 'どれも目利きの品です。ゆっくりご覧になって'],
    evening: ['おかえりなさい。夕方の棚もそろってますよ', '今日もおつかれさまです。何か入り用ですか？'],
    night: ['遅くまでおつかれさまです。灯り、もう少しつけておきますね', '夜更けのお客さんですね。帳簿をつけながらお待ちしてました'],
  },
  poor: ['銭がたまったら、またのぞいてくださいね', '今日はお目当て、なさそうですか？ またどうぞ'],
  goods: ['品物は買うたびに少し値が上がって、日付が変わると戻りますよ', 'ガチャ券と錬成札は、1日に買える数が決まってますよ'],
  items: ['道具は一度買えば、ずっと使えますよ', '戦の役に立つ道具ばかりです。見ていってください'],
  bought: ['まいどありがとうございます', 'いい買い物でしたね', 'はい、どうぞ。大事に使ってくださいね'],
  unlocked: ['{name}、確かにお渡ししました。戦でいつでも使えますよ'],
  poke: ['狐だからって化かしたりしませんよ。…たぶん', 'こまちの算盤、ここまで聞こえてきません？', '帳簿は毎晩つけてるんです', 'おすすめ？ ふふ、全部ですよ'],
};

const last = new Map<readonly string[], number>();
/** 候補から1つ（直前と同じものは避ける）。{n}・{name} を差し込む */
export function pick(list: readonly string[], vars: Record<string, string | number> = {}): string {
  let i = Math.floor(Math.random() * list.length);
  if (list.length > 1 && i === last.get(list)) i = (i + 1) % list.length;
  last.set(list, i);
  return list[i].replace(/\{(\w+)\}/g, (_, k) => String(vars[k] ?? ''));
}
